<div class="container mx-auto p-6 max-w-6xl">
  <div class="mb-8 flex justify-between items-center">
    <div>
      <h1 class="text-3xl font-bold text-gray-800 mb-2">Upravljanje kategorij</h1>
      <p class="text-gray-600">Dodajte in upravljajte kategorije tekmovalcev</p>
    </div>
    <button class="bg-blue-500 text-white border-none rounded-lg px-6 py-3 cursor-pointer text-base font-semibold transition-all hover:bg-blue-600 hover:shadow-lg transform hover:-translate-y-0.5 shadow-md" (click)="openAddDialog()">
      <i class="fas fa-plus mr-2"></i>Dodaj kategorijo
    </button>
  </div>
  <div class="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden" *ngIf="categories.length > 0">
    <div class="bg-gradient-to-r from-blue-500 to-blue-600 px-6 py-4">
      <h2 class="text-white text-xl font-bold flex items-center">
        <i class="fas fa-tags mr-3"></i>Seznam kategorij
        <span class="ml-auto text-blue-100 text-sm font-normal">
          {{ categories.length }} kategorij
        </span>
      </h2>
    </div>
    <table class="w-full border-collapse">
      <thead>
        <tr class="bg-gray-50">
          <th class="px-6 py-4 text-left font-bold text-gray-700 border-b-2 border-gray-200 text-sm uppercase tracking-wider">
            <i class="fas fa-hashtag mr-2"></i>ID
          </th>
          <th class="px-6 py-4 text-left font-bold text-gray-700 border-b-2 border-gray-200 text-sm uppercase tracking-wider">
            <i class="fas fa-tag mr-2"></i>Naziv kategorije
          </th>
          <th class="px-6 py-4 text-center font-bold text-gray-700 border-b-2 border-gray-200 text-sm uppercase tracking-wider">
            <i class="fas fa-cogs mr-2"></i>Dejanja
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200">
        <tr class="hover:bg-blue-50 transition-colors duration-200" *ngFor="let cat of categories; let i = index">
          <td class="px-6 py-4 text-left">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              {{ cat.category_id }}
            </span>
          </td>
          <td class="px-6 py-4 text-left">
            <div class="flex items-center">
              <div class="w-8 h-8 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full flex items-center justify-center mr-3">
                <span class="text-white text-sm font-bold">{{ cat.category_name.charAt(0).toUpperCase() }}</span>
              </div>
              <span class="text-gray-900 font-medium">{{ cat.category_name }}</span>
            </div>
          </td>
          <td class="px-6 py-4 text-center">
            <button class="bg-blue-500 text-white border-none rounded-lg px-4 py-2 cursor-pointer text-sm font-medium transition-all hover:bg-blue-600 hover:shadow-md transform hover:-translate-y-0.5" (click)="onEdit(cat)">
              <i class="fas fa-edit mr-1"></i>Uredi
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="text-center my-12 bg-gray-50 p-8 rounded-xl border-2 border-dashed border-gray-300" *ngIf="categories.length === 0">
    <i class="fas fa-tags text-gray-400 text-4xl mb-4"></i>
    <h3 class="text-xl font-semibold text-gray-600 mb-2">Ni kategorij</h3>
    <p class="text-gray-500 mb-4">Dodajte prvo kategorijo za organizacijo tekmovalcev</p>
    <button class="bg-blue-500 text-white border-none rounded-lg px-6 py-3 cursor-pointer text-base font-semibold transition-all hover:bg-blue-600 hover:shadow-lg transform hover:-translate-y-0.5" (click)="openAddDialog()">
      <i class="fas fa-plus mr-2"></i>Dodaj prvo kategorijo
    </button>
  </div>

  <ng-container *ngIf="addDialogOpen">
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
      <app-category-add-dialog (save)="onDialogSave()" (cancel)="addDialogOpen = false"></app-category-add-dialog>
    </div>
  </ng-container>

  <ng-container *ngIf="editDialogOpen">
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
      <app-category-add-dialog
        [category]="categoryToEdit"
        (save)="onDialogSave()"
        (cancel)="editDialogOpen = false">
      </app-category-add-dialog>
    </div>
  </ng-container>
</div>